import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {AuthGuard} from "../guards/auth.guard";
import {PlanGuard} from "../guards/plan.guard";
import {AppService} from "../app.service";
import {AssetsComponent} from "./assets.component";
import {AssetsImporterComponent} from "./assets-importer/assets-importer.component";

const routes: Routes = [
  {
    path: 'asset-register',
    component: AssetsComponent,
    canActivate: [
      AuthGuard,
      PlanGuard
    ],
    data: { planFeature: AppService.FEATURES.ASSETS }
  },
  {
    path: 'asset-register/importer',
    component: AssetsImporterComponent,
    canActivate: [
      AuthGuard,
      PlanGuard
    ],
    data: { planFeature: AppService.FEATURES.ASSETS }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AssetsRoutingModule { }
